import * as React from "react";
import { DatePicker } from "../../../../../../../react-core/Datepicker/DatePicker";
import { RadiosEditor } from "../../../../../../../react-core/Html/RadiosEditor";
import { SelectEditor } from "../../../../../../../react-core/Html/SelectEditor";
import { JsonDateParser } from "../../../../../../../react-core/Utils/JsonDateParser";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../Shared/Process/Process/ProcessComponent";
import { PensionContribution } from "../../../../../../../Wrap/Models/Models/Processes/Apply/Pension/PensionContribution";
import { AnnuityPaymentsTypeOptions, AnnuityPaymentsTypeOptionsMap, PensionAnnuityAssumptionGuaranteePeriodArray, PensionAnnuityAssumptionPensionIncreaseArray, PensionAnnuityAssumptionText, datePickerOptions } from "../../Resource/Contents";
import { ProcessType } from "../../../../../../Shared/IST/Resource/Content";
import { Numeric } from "../../../../../../../react-core/Html/Validation/RegExPatterns";
import { NumberTextBoxEditor } from "../../../../../../../react-core/Html/NumberTextBoxEditor";
import {PensionAnnuityAssumption as PensionAnnuityAssumptionClass} from "../../../../../../../Wrap/Models/Domains/Account/PensionAnnuityAssumption";
import { AnnuityPaymentsType } from "../../../../../../../Wrap/Constants/Enums/Domain/AnnuityPaymentsType";

interface IPensionAnnuityAssumptionProps extends IProcessComponentProps {
    data: PensionContribution;
    processType: ProcessType;
}

interface IPensionAnnuityAssumptionState {}

export class PensionAnnuityAssumption extends ProcessComponent<
    IPensionAnnuityAssumptionProps,
    IPensionAnnuityAssumptionState
> {
    constructor(props: any) {
        super(props);
        this.state = {};
        delete datePickerOptions.todayButton;
    }

    private onPensionAnnuityAssumptionChange(changes) {
        const { data, onChange } = this.props;
        this.onDataChange(
            onChange,
            changes,
            data,
            "PensionAnnuityAssumption"
        )
    }

    private getDefaultPensionAnnuityAssumption() : PensionAnnuityAssumptionClass
    {
        var annuityAssumption:PensionAnnuityAssumptionClass=
        {
            PaymentInType : AnnuityPaymentsType.Advance,
            IfAddSpousePension: false,
            PaymentIndexationLevel:0,
            GuaranteePeriod:5
        }
        return annuityAssumption;
    }

    public render(): JSX.Element {
        const { data, onChange } = this.props;
        return (
            <>
                <div className="row">
                    <div className="col-auto">
                        <RadiosEditor
                            cssWrapper="radio-group rg-inline rg-150 mb-23"
                            selected={
                                data?.PensionAnnuityAssumption != null
                            }
                            options={[true, false]}
                            label={PensionAnnuityAssumptionText.QuestionText}
                            getText={(v) => {
                                return v ? "Yes" : "No";
                            }}
                            onChange={(v) => {
                                if (v) {
                                    this.onDataChange(onChange, { PensionAnnuityAssumption: this.getDefaultPensionAnnuityAssumption() }, data);
                                }
                                else {
                                    this.onDataChange(onChange, { PensionAnnuityAssumption: null }, data);
                                }
                            }}
                        />
                    </div>
                </div>
                {[ProcessType.NB, ProcessType.NBEC].includes(this.props.processType) && data?.PensionAnnuityAssumption != null &&
                    <div className="row">
                        <div className="col-auto">
                            <RadiosEditor
                                cssWrapper="radio-group rg-inline rg-150 mb-23"
                                selected={data?.PensionAnnuityAssumption?.PaymentInType}
                                options={AnnuityPaymentsTypeOptions}
                                label={PensionAnnuityAssumptionText.PaymentInLabel}
                                getText={(v) => {
                                    return AnnuityPaymentsTypeOptionsMap[v];
                                }}
                                onChange={(v) =>
                                    this.onPensionAnnuityAssumptionChange({PaymentInType: v})
                                }
                            />
                        </div>
                    </div>
                }
                {[ProcessType.NB, ProcessType.NBEC].includes(this.props.processType) && data?.PensionAnnuityAssumption != null &&
                    <div className="row">
                        <div className="col-auto">
                            <RadiosEditor
                                cssWrapper="radio-group rg-inline rg-150 mb-23"
                                selected={data?.PensionAnnuityAssumption?.IfAddSpousePension}
                                options={[true,false]}
                                label={PensionAnnuityAssumptionText.SpousePensionQsText}
                                getText={(v) => {
                                    return v?"Yes":"No"
                                }}
                                onChange={(v) =>
                                    this.onPensionAnnuityAssumptionChange({IfAddSpousePension: v})
                                }
                            />
                        </div>
                    </div>
                }
                {data?.PensionAnnuityAssumption?.IfAddSpousePension &&
                    <div className="row">
                        <div className="col-auto">
                            <NumberTextBoxEditor
                                allowedCharacters={Numeric}
                                label={"Spouse's pension percentage"}
                                required={`Please enter spouses pension`}
                                value={data?.PensionAnnuityAssumption?.SpousePensionPercentage}
                                atLeast={{ value: 0, errorMessage: "Number entered must be ≥ 0" }}
                                atMost={{ value: 100, errorMessage: "Number entered must be no greater than 100." }}
                                onChange={(v) => {
                                    this.onPensionAnnuityAssumptionChange({SpousePensionPercentage: v})
                                }}
                                cssWrapper="mb-10 text-align-center"
                            />
                        </div>
                    </div>
                }
                {data?.PensionAnnuityAssumption?.IfAddSpousePension &&
                    <div className="row">
                        <div className="col-auto">
                        <DatePicker
                            selected={JsonDateParser.toDateNoOffset(data?.PensionAnnuityAssumption?.SpouseDoB)}
                            label={"Spouse's Date of Birth"}
                            required={`Please choose spouse's date of birth`}
                            onChange={(v) => {
                                this.onPensionAnnuityAssumptionChange({SpouseDoB: v})
                            }}
                            {...datePickerOptions}
                            formGroupCssWrapper="mb-10"
                        />
                        </div>
                    </div>
                }
                {data?.PensionAnnuityAssumption?.IfAddSpousePension &&
                    <div className="row">
                        <div className="col-auto">
                            <RadiosEditor
                                    cssWrapper="radio-group rg-inline rg-150 mb-23"
                                    selected={data?.PensionAnnuityAssumption?.SpouseGender}
                                    required={`Please select spouse gender`}
                                    options={["Male","Female"]}
                                    label={"Spouse's Gender"}
                                    getText={(v) => {
                                        return v
                                    }}
                                    onChange={(v) =>
                                        this.onPensionAnnuityAssumptionChange({SpouseGender: v})
                                    }
                            />
                        </div>
                    </div>
                }
                {data?.PensionAnnuityAssumption != null &&
                    <div className="row">
                        <div className="col-auto">
                        <SelectEditor
                            cssWrapper="rg-inline mb-16"
                            label={"Pension Increase"}
                            selected={data?.PensionAnnuityAssumption?.IfRPI ? "RPI" : data?.PensionAnnuityAssumption?.PaymentIndexationLevel}
                            options={PensionAnnuityAssumptionPensionIncreaseArray}
                            getText={(o) => 
                                {
                                    if(o=="RPI") return o;
                                    else return o + "%"
                                }
                            }
                            onChange={(v) => {
                                if(v=="RPI"){
                                    this.onPensionAnnuityAssumptionChange({IfRPI: true, PaymentIndexationLevel:null })
                                }
                                else{
                                    this.onPensionAnnuityAssumptionChange({IfRPI: false, PaymentIndexationLevel:v })
                                }
                            }}
                            required={"Please select Pension Increase"}
                        />
                        </div>
                    </div>
                }
                {data?.PensionAnnuityAssumption != null &&
                    <div className="row">
                        <div className="col-auto">
                        <SelectEditor
                            cssWrapper="rg-inline mb-16"
                            label={"Guarantee period"}
                            selected={data?.PensionAnnuityAssumption?.GuaranteePeriod}
                            options={PensionAnnuityAssumptionGuaranteePeriodArray}
                            getText={(o) => {return o + " years"}}
                            onChange={(v) => {
                                this.onPensionAnnuityAssumptionChange({GuaranteePeriod: v })
                            }}
                            required={"Please select Guarantee period"}
                        />
                        </div>
                    </div>
                }
            </>
        );
    }
}
